import React from 'react'
import {Card, CardContent} from '@/components/ui/card'
import Heading from '../typography/heading'
import BodyCopy from '../typography/body-copy'

const LevelInstructionsCard = () => (
    <Card
        className="bg-white/90 flex-1 p-8 rounded-md border-gray-05 max-w-[30.75rem]"
        data-testid="levelInstructionsCard"
    >
        <CardContent
            className="flex flex-col h-full"
            data-testid="levelInstructionsCard-CardContent"
        >
            <div className="px-3 py-4 text-left">
                <Heading
                    tag="h2"
                    variant="h6"
                    content="Your Lessons"
                    data-testid="levelInstructionsCard-Heading"
                />
                <BodyCopy
                    content={
                        <>
                            Complete more lessons to build your knowledge and get closer to your
                            financial goals! And, get rewarded and earn{' '}
                            <span className="text-blue-600 hover:text-blue-800 underline">
                                <a href="/loyalty-perks">Perk Points</a>
                            </span>{' '}
                            from HSA Store for completing your learning.
                        </>
                    }
                    data-testid="levelInstructionsCard-BodyCopy"
                />
            </div>
        </CardContent>
    </Card>
)

export default LevelInstructionsCard
